import React from 'react';
import { Users, Crown, Zap, MessageSquare } from 'lucide-react';

export const StatsPanel = ({ showStats, stats }) => {
  if (!showStats) return null;

  return (
    <div className="mb-4 p-4 bg-gray-800 rounded-xl border border-gray-700 animate-slide-down">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-gray-700/30 p-3 rounded-lg">
          <div className="flex items-center gap-2 mb-1">
            <Users className="w-4 h-4 text-blue-400" />
            <span className="text-xs text-gray-400">Всего</span>
          </div>
          <p className="text-xl font-bold text-white">{stats.total}</p>
        </div>
        <div className="bg-gray-700/30 p-3 rounded-lg">
          <div className="flex items-center gap-2 mb-1">
            <Crown className="w-4 h-4 text-yellow-400" />
            <span className="text-xs text-gray-400">Premium</span>
          </div>
          <p className="text-xl font-bold text-white">{stats.premium}</p>
          <p className="text-xs text-gray-400">Free: {stats.free}</p>
        </div>
        <div className="bg-gray-700/30 p-3 rounded-lg">
          <div className="flex items-center gap-2 mb-1">
            <Zap className="w-4 h-4 text-blue-400" />
            <span className="text-xs text-gray-400">Авто</span>
          </div>
          <p className="text-xl font-bold text-white">{stats.auto}</p>
          <p className="text-xs text-gray-400">Ручные: {stats.manual}</p>
        </div>
        <div className="bg-gray-700/30 p-3 rounded-lg">
          <div className="flex items-center gap-2 mb-1">
            <MessageSquare className="w-4 h-4 text-green-400" />
            <span className="text-xs text-gray-400">Контакты</span>
          </div>
          <p className="text-xl font-bold text-white">{stats.withPhone}</p>
          <p className="text-xs text-gray-400">Email: {stats.withEmail}</p>
        </div>
      </div>
    </div>
  );
};